const LOGO_URL = "/logo.png";

export const HomeCareLogoIcon = ({ className = "w-10 h-10" }) => (
  <img
    src={LOGO_URL}
    alt="Caceres Essential Care Logo"
    className={className}
    style={{ objectFit: "contain" }}
  />
);
